package com.arenaproplay.admin.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.arenaproplay.admin.navigation.Routes
import com.arenaproplay.admin.ui.utils.encodeQueryValue
import com.arenaproplay.admin.ui.utils.urlParam

/**
 * Legacy /dashboard route — redirects to /analytics.
 *
 * «Командный центр» merged into the Аналитика page: hero KPIs, PRO revenue and
 * the activity chart now live on the «Источники и гео» tab (replacing the world
 * map). This stub keeps old bookmarks working.
 */
@Page("/dashboard")
@Composable
fun DashboardPage() {
    val ctx = rememberPageContext()
    LaunchedEffect(Unit) {
        val period = urlParam("period")?.let { "?period=${encodeQueryValue(it)}" } ?: ""
        ctx.router.navigateTo("${Routes.ANALYTICS}$period")
    }
}
